import { render, staticRenderFns } from "./icon-arrow-quarternary.vue?vue&type=template&id=b61a9bb8&scoped=true&"
import script from "./icon-arrow-quarternary.vue?vue&type=script&lang=js&"
export * from "./icon-arrow-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61a9bb8",
  null
  
)

export default component.exports